import React from 'react';
import {Link} from 'react-router-dom';
import {GridLinkButton} from 'components/common/GridLinkButton';
import {CommonStatusBadge} from 'components/common/StatusBadge';
import DateFnsUtils from '@date-io/date-fns';
import {DEFAULT_DATE_FORMAT} from '../../constants/reports';
const dateFns = new DateFnsUtils();

export const PUBLISHER_GRID_COLUMNS = [
  {
    field: 'id',
    headerName: 'Name',
    sortable: true,
    disableClickEventBubbling: true,
    renderCell: ({row}) => <GridLinkButton component={Link} to={`/publishers/${row.id}/edit`}>({row.id}) {row.name}</GridLinkButton>,
    sortComparator: (v1, v2) => v1 - v2,
    flex: 1,
  },
  {
    field: 'status',
    headerName: 'Status',
    disableClickEventBubbling: true,
    renderCell: (params) => <CommonStatusBadge status={params.value} />,
    sortable: true,
    flex: 1,
  },
  {
    field: 'balance',
    headerName: 'Balance',
    sortable: true,
    flex: 1,
  },
  {
    field: 'createdAt',
    headerName: 'Registered',
    valueFormatter: (value='-') =>dateFns.format(new Date(value), DEFAULT_DATE_FORMAT),
    sortable: true,
    flex: 1,
  },
];
